"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryfy = void 0;
const utils_1 = require("../common/utils/utils");
function getRetriesArray(input) {
    if (Array.isArray(input)) {
        return input;
    }
    if (!Number.isNaN(input) && Number.isInteger(input)) {
        return Array(input).fill(1).map(() => 1000);
    }
    if (typeof input === 'object') {
        const config = input;
        if (config.retries && config.delaysArray) {
            throw new Error('You can not provide both retries and delaysArray');
        }
        if (config.delaysArray) {
            return config.delaysArray;
        }
        return Array(input.retries).fill(1).map(() => { var _a; return (_a = input.delay) !== null && _a !== void 0 ? _a : 1000; });
    }
    throw new Error('invalid input');
}
function getOnRetry(input, context) {
    if (typeof input === 'object') {
        if (typeof input.onRetry === 'string') {
            return context[input.onRetry].bind(context);
        }
        return input.onRetry;
    }
    return undefined;
}
function exec(originalMethod, args, retriesArr, callsMadeSoFar, onRetry) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield originalMethod.apply(this, args);
            return res;
        }
        catch (e) {
            if (callsMadeSoFar < retriesArr.length) {
                if (onRetry) {
                    onRetry(e, callsMadeSoFar);
                }
                yield (0, utils_1.sleep)(retriesArr[callsMadeSoFar]);
                return exec(originalMethod, args, retriesArr, callsMadeSoFar + 1, onRetry);
            }
            throw e;
        }
    });
}
function retryfy(originalMethod, input) {
    const retriesArray = getRetriesArray(input);
    return function (...args) {
        const onRetry = getOnRetry(input, this);
        return exec(originalMethod.bind(this), args, retriesArray, 0, onRetry);
    };
}
exports.retryfy = retryfy;
